export const SUPER_PREFERRED = "1";
export const PREFERRED = "3";
export const STANDARD_PLUS = "4";
export const STANDARD = "5";

export const RATE_CLASSES_VALUES = [
    SUPER_PREFERRED,
    PREFERRED,
    STANDARD_PLUS,
    STANDARD,
];

export const RATE_CLASSES_BY_HEALTH_VALUE = {
    5: [SUPER_PREFERRED],
    4: [PREFERRED],
    3: [STANDARD_PLUS],
    2: [STANDARD],
    1: [STANDARD],
}
